<script lang="ts">
  import { Button, Col, Row, Table, Tooltip } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { HoverMessage, LinktooltipMessage, Primary, TooltipTriggers, outlinebutton, outlinebuttonMessage } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card headerTitle={TooltipTriggers}>
      <div slot="contentbody">
        <Row class="card-block">
          <Col sm="12" lg="12" xl="12">
            <div class="table-responsive">
              <Table bordered>
                <tbody>
                  <tr>
                    <td>{'Hover'}</td>
                    <td class="w-50">
                        <Button id="btn-right-html" color="primary">{Primary}</Button>
                        <Tooltip target="btn-right-html" placement="bottom">{'Hover'}</Tooltip>
                    </td>
                    <td><span>{HoverMessage}</span></td>
                  </tr>
                  <tr>
                    <td>{'Link'}</td>
                    <td class="w-50">
                        <Button id="btn-right" color="primary">{'Link'}</Button>
                        <Tooltip target="btn-right" placement="bottom">{'Hover'}</Tooltip>
                    </td>
                    <td><span>{@html LinktooltipMessage}</span></td>
                  </tr>
                  <tr>
                    <td>{outlinebutton}</td>
                    <td class="w-50">
                        <Button id="btn-html" color="primary">{Primary}</Button>
                        <Tooltip target="btn-html" placement="bottom">{'Hover'}</Tooltip>
                    </td>
                    <td><span>{@html outlinebuttonMessage}</span></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Col>